module.exports = "/_next/static/images/technologiesUse-2x-40e9563e3da3abb014305fedf501467e.jpg.webp";